import { styles } from "../../../common/views/DefaultStyles";
import { Utils } from "../../../common/views/Utils";
import { ProductUtils } from "../../../products/ProductUtils";
import { OrderConfirmModel } from "../../models/OrderModel";

export type OrderConfirmationProps = {
    model: OrderConfirmModel;
}

export default function OrderConfirmationView({ model }: OrderConfirmationProps) {
    const isMobile = window.innerWidth <= 500;
    const id = "login-form-wrapper" + (isMobile ? "-mobile" : "");

    const width3 = Utils.getColumnWidth(3);
    const width9 = Utils.getColumnWidth(9);

    const homeButton = () => {
        window.open("/", "_self");
    }

    const mainContent = () => {
        return <div className="pv-10 ph-15">
            <div className="font-title">Thanks for ordering with us!</div>
            <div className="pt-15">Order #: {model.id}</div>
            <div className="pt-15">Total Amount: $ {model.total.toFixed(2)}</div>
            <div className="pt-15">Order Date: {Utils.formatShortDate(model.date)}</div>

            {model.earningPoints > 0 && <>
                <div className="font-bolder pt-20">Congratulation!</div>
                <div className="pt-10">
                    <span>You've earned</span>
                    <span className="ph-5 font-bolder">{model.earningPoints} points</span>
                    <span>{ProductUtils.printStarIcon()} for this order</span>
                </div>
            </>}

            <div className="ms-Grid-row pt-20 font-smaller">
                <div className={width9 + " left gray"}>Our team will contact you shortly.</div>
                <div className={width3 + " right"}>
                    <a className="pointer" onClick={homeButton} style={{ textDecoration: "underline" }}>
                        Continue Shopping
                    </a>
                </div>
            </div>
        </div>;
    }

    return <div id={id} className="p-10">
        <div className="box center" style={{ width: "100%" }}>
            {mainContent()}
        </div>
    </div>;
}